import React from "react";

const PointIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Point- icon">
    <circle id="Ellipse 1" cx="7.75" cy="8.25" r="6.75" stroke="black"/>
    <circle id="Ellipse 2" cx="7.75" cy="8.25" r="4.75" stroke="black"/>
    <circle id="Ellipse 3" cx="7.75" cy="8.25" r="2.25" fill="black"/>
    </g>
    </svg>
  );
};

export default PointIcon;

